import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateUsers = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 498.09 493.26",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{opacity:.1;}.d{fill:#ebf3ff;}.e{fill:#fafcff;}.f{fill:#9ec5ff;}.g{fill:#b5c5ea;}.h{fill:#dcebfe;}.i,.j{fill:none;stroke:#ebf3ff;stroke-miterlimit:10;stroke-width:5px;}.j{stroke-linecap:round;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "e",
				cx: 246.8,
				cy: 246.79,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					className: "d",
					x: 143.65,
					y: 85.86,
					width: 354.43,
					height: 330.03,
					rx: 5,
					ry: 5
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "h",
					x: 178.09,
					y: 121.12,
					width: 285.57,
					height: 47.09
				}), /* @__PURE__ */ _jsx("rect", {
					className: "g",
					x: 178.09,
					y: 121.12,
					width: 80.55,
					height: 47.09
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M380.88,257.66c0,17.06-7.11,32.44-18.54,43.36-10.76,10.31-25.38,16.64-41.46,16.64s-30.68-6.31-41.46-16.62c-11.43-10.92-18.54-26.31-18.54-43.38,0-33.13,26.85-60,60-60s60,26.87,60,60Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M362.33,301.02c-10.76,10.31-25.38,16.64-41.46,16.64s-30.68-6.31-41.46-16.62c2.65-17.24,15.79-30.99,32.68-34.58-8.87-3.5-15.17-12.14-15.17-22.28,0-13.23,10.72-23.95,23.95-23.95s23.95,10.72,23.95,23.95c0,10.14-6.3,18.78-15.19,22.28,16.89,3.59,30.03,17.35,32.69,34.56Z"
				})] }),
				/* @__PURE__ */ _jsx("rect", {
					className: "g",
					x: 218.8,
					y: 376.76,
					width: 204.14,
					height: 9.71,
					rx: 4.86,
					ry: 4.86
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("rect", {
						className: "g",
						x: 310.43,
						y: 349.55,
						width: 22.7,
						height: 9.71,
						rx: 4.86,
						ry: 4.86
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "g",
						x: 261.44,
						y: 349.55,
						width: 40.84,
						height: 9.71,
						rx: 4.86,
						ry: 4.86
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "g",
						x: 339.46,
						y: 349.55,
						width: 40.84,
						height: 9.71,
						rx: 4.86,
						ry: 4.86
					})
				] }),
				/* @__PURE__ */ _jsx("rect", {
					className: "d",
					x: 197.94,
					y: 139.81,
					width: 40.84,
					height: 9.71,
					rx: 4.86,
					ry: 4.86
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "c",
					x: 61.09,
					y: 237.41,
					width: 110.98,
					height: 88.66,
					rx: 10.07,
					ry: 10.07
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 55.62,
					y: 233.02,
					width: 110.98,
					height: 88.66,
					rx: 9.93,
					ry: 9.93
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("circle", {
					className: "i",
					cx: 109.03,
					cy: 275.32,
					r: 16.16
				}), /* @__PURE__ */ _jsx("line", {
					className: "j",
					x1: 121.18,
					y1: 287.57,
					x2: 129.36,
					y2: 295.54
				})] })
			]
		})
	]
});
export default SvgEmptyStateUsers;
